import { call, put } from 'redux-saga/effects';
import { BACKEND_URL, FRONT_URL } from '../../../configs';
import {
  callCallbackEsiaFailed,
  callCallbackEsiaSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';

export default function* callCallbackEsia(action) {
  try {
    const url = `${BACKEND_URL}/auth/trust-gate/callback`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse?.status === OK && data) {
      yield put(callCallbackEsiaSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(callCallbackEsiaFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(callCallbackEsiaFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
